import { Directive, EventEmitter, HostBinding, HostListener, Output } from "@angular/core";

@Directive({
	selector: "[appDragDrop]",
	standalone: false
})
export class DragDropDirective {
	@Output() onFileDropped = new EventEmitter<any>();

	@HostBinding("style.background-color") protected background = "#f5fcff";
	@HostBinding("style.opacity") protected opacity = 1;

	// Dragover listener
	@HostListener("dragenter", ["$event"]) onDragEnter(evt) {
		evt.preventDefault();
		evt.stopPropagation();
		this.background = "#9ecbec";
		this.opacity = .8;
	}
	// Dragleave listener
	@HostListener("dragleave", ["$event"]) public onDragLeave(evt) {
		evt.preventDefault();
		evt.stopPropagation();
		this.background = "#f5fcff";
		this.opacity = 1;
	}
	// Drop listener
	@HostListener("drop", ["$event"]) public ondrop(evt) {
		evt.preventDefault();
		evt.stopPropagation();
		this.background = "#f5fcff";
		this.opacity = 1;
		const files = evt.dataTransfer.files;
		if (files.length > 0) {
			this.onFileDropped.emit(files);
		}
	}
}